export default {
    GLOBAL_PAYMENTS: '9ad90aca-0243-417c-a286-8b7a9aafe7ac',
    AXIAMED: 'f722b17a-4bfd-4c59-a1e3-57ffa5b110c4'
};



// WEBPACK FOOTER //
// ./src/components/common/payment-gateways.js